import { render, staticRenderFns } from "./OpinionCollect.vue?vue&type=template&id=a7949cd0"
import script from "./OpinionCollect.vue?vue&type=script&lang=js"
export * from "./OpinionCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports